import React, { useState } from "react";
import { FormattedHTMLMessage, useIntl } from "gatsby-plugin-intl";
import "./samsungEarthquakeNoticeModal.scss";
import SamsungModalPopup from "../modal/SamsungModal";

const SamsungEarthquakeNoticeModal = () => {
  const [showModal, setShowModal] = useState(true);
  const intl = useIntl();

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <SamsungModalPopup
      show={showModal}
      onClose={handleClose}
      heading={intl.formatMessage({ id: "earthquakeModalTitle" })}
      size="lg"
    >
      <hr className="earthquake-modal-divider" />
      <div className="earthquake-notice-content">
        <FormattedHTMLMessage id="earthquakeModalContent" />
      </div>
    </SamsungModalPopup>
  );
};

export default SamsungEarthquakeNoticeModal;
